import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'
import { useTranslation } from 'react-i18next'
import {
  createVisit,
  getUploadLink,
  uploadDeliberateliesFiles,
  uploadNotHealthyAutoPartsFiles,
  uploadNotHealthyAutoPartsFilesPodSpace,
  uploadVehicleAccessoriesFiles,
  uploadVehicleAccessoriesFilesPodSpace,
  uploadVehicleVisitingPointFiles,
  uploadVehicleVisitingPointFilesPodSpace,
} from 'Application/Visits/Actions/action'
import React from 'react'
import {
  setSkipVideo,
  setVehicleVisitingPointFileContent,
} from 'Application/Visits/Actions/reducer'
import Icon from 'Components/Icon'
import PodSpaceImage from 'Components/Image/PodSpaceImage'
import { useSettings } from 'Contexts/SettingsContext'
import Const from 'Utils/Consts'
import { useNavigate } from 'react-router-dom'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import { useAppDispatch } from 'Hooks/reduxHooks'
import gregorianDate from 'Utils/gregorianDate'
import { ToastErrorBottomLeft } from 'Utils/toastService'

const SendToServerPage = () => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const videoFormat = settings?.REACT_APP_VIDEO_FORMAT ?? Const.env.REACT_APP_VIDEO_FORMAT
  const canSkipVideo = settings?.REACT_APP_CAN_SKIP_VIDEO ?? Const.env.REACT_APP_CAN_SKIP_VIDEO
  const updateWithOutError =
    settings?.REACT_APP_UPDATE_WITH_OUT_ERROR ?? Const.env.REACT_APP_UPDATE_WITH_OUT_ERROR
  const uploadLinkSize =
    (settings?.REACT_APP_UPLOAD_LINK_SIZE ?? Const.env.REACT_APP_UPLOAD_LINK_SIZE) || 10200

  const newVisit = useSelector((store: IApplicationState) => store.visits.newVisit)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const videoPlayerRef = useRef<HTMLVideoElement>(null)

  const customerDeliberately = () =>
    (newVisit.customerDeliberately.nationalCard != undefined &&
      newVisit.customerDeliberately.nationalCard.status != 1) ||
    (newVisit.customerDeliberately.nationalCardBack != undefined &&
      newVisit.customerDeliberately.nationalCardBack.status != 1) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
      newVisit.customerDeliberately.vehicleCard != undefined &&
      newVisit.customerDeliberately.vehicleCard.status != 1) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
      newVisit.customerDeliberately.nationalCardBack != undefined &&
      newVisit.customerDeliberately.nationalCardBack.status != 1) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
      newVisit.customerDeliberately.vehicleDoc != undefined &&
      newVisit.customerDeliberately.vehicleDoc.status != 1) ||
    (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
      newVisit.customerDeliberately.vehicleCompanyDoc != undefined &&
      newVisit.customerDeliberately.vehicleCompanyDoc.status != 1)

  useEffect(() => {
    if (
      newVisit.vehicleVisitingPoints.recordedChunks &&
      newVisit.vehicleVisitingPoints.recordedChunks.length &&
      !newVisit.vehicleVisitingPoints.skipVideo
    ) {
      const blob = new Blob(newVisit.vehicleVisitingPoints.recordedChunks, {
        type: videoFormat,
      })
      const url = URL.createObjectURL(blob)
      if (videoPlayerRef.current) {
        videoPlayerRef.current.src = url
        videoPlayerRef.current.play()
      }
    }
  }, [])

  useEffect(() => {
    if (
      !newVisit.customerDeliberately.loading &&
      !newVisit.vehicleVisitingPoints.loading &&
      !newVisit.vehicleVisitingPoints.videoLoading &&
      !newVisit.notHealthyAutoParts.loading &&
      !newVisit.vehicleAccessories.loading
    ) {
      if (
        !(newVisit.customerDeliberately.nationalCard != undefined &&
          newVisit.customerDeliberately.nationalCard.status != 1,
        (newVisit.customerDeliberately.nationalCardBack != undefined &&
          newVisit.customerDeliberately.nationalCardBack.status != 1) ||
          (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
            newVisit.customerDeliberately.vehicleCard != undefined &&
            newVisit.customerDeliberately.vehicleCard.status != 1) ||
          (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
            newVisit.customerDeliberately.nationalCardBack != undefined &&
            newVisit.customerDeliberately.nationalCardBack.status != 1) ||
          (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
            newVisit.customerDeliberately.vehicleDoc != undefined &&
            newVisit.customerDeliberately.vehicleDoc.status != 1) ||
          (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
            newVisit.customerDeliberately.vehicleCompanyDoc != undefined &&
            newVisit.customerDeliberately.vehicleCompanyDoc.status != 1)) &&
        !newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) &&
        (newVisit.vehicleVisitingPoints.skipVideo ||
          newVisit.vehicleVisitingPoints.videoStatus == 1) &&
        !newVisit.notHealthyAutoParts.data.some(x => x.status != 1) &&
        !newVisit.vehicleAccessories.data.some(x => x.status != 1)
      ) {
        saveVisit()
      }
    }
  }, [
    newVisit.customerDeliberately.loading,
    newVisit.vehicleVisitingPoints.loading,
    newVisit.vehicleVisitingPoints.videoLoading,
    newVisit.notHealthyAutoParts.loading,
    newVisit.vehicleAccessories.loading,
  ])

  const checkIsJustVideoFile = (): boolean => {
    if (
      (newVisit.customerDeliberately.nationalCard != undefined &&
        newVisit.customerDeliberately.nationalCard.status != 1,
      (newVisit.customerDeliberately.nationalCardBack != undefined &&
        newVisit.customerDeliberately.nationalCardBack.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
          newVisit.customerDeliberately.vehicleCard != undefined &&
          newVisit.customerDeliberately.vehicleCard.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
          newVisit.customerDeliberately.nationalCardBack != undefined &&
          newVisit.customerDeliberately.nationalCardBack.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
          newVisit.customerDeliberately.vehicleDoc != undefined &&
          newVisit.customerDeliberately.vehicleDoc.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
          newVisit.customerDeliberately.vehicleCompanyDoc != undefined &&
          newVisit.customerDeliberately.vehicleCompanyDoc.status != 1))
    )
      return false

    if (newVisit.vehicleVisitingPoints.data.some(x => x.status != 1)) return false

    if (newVisit.vehicleVisitingPoints.videoStatus == 1 || newVisit.vehicleVisitingPoints.skipVideo)
      return false

    return true
  }

  const onSaveHandleClick = () => {
    if (
      (newVisit.customerDeliberately.nationalCard != undefined &&
        newVisit.customerDeliberately.nationalCard.status != 1,
      (newVisit.customerDeliberately.nationalCardBack != undefined &&
        newVisit.customerDeliberately.nationalCardBack.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
          newVisit.customerDeliberately.vehicleCard != undefined &&
          newVisit.customerDeliberately.vehicleCard.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
          newVisit.customerDeliberately.nationalCardBack != undefined &&
          newVisit.customerDeliberately.nationalCardBack.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
          newVisit.customerDeliberately.vehicleDoc != undefined &&
          newVisit.customerDeliberately.vehicleDoc.status != 1) ||
        (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
          newVisit.customerDeliberately.vehicleCompanyDoc != undefined &&
          newVisit.customerDeliberately.vehicleCompanyDoc.status != 1))
    ) {
      uploadCustomerDeliberatelyImages()
      return
    }

    if (newVisit.vehicleVisitingPoints.data.some(x => x.status != 1)) {
      uploadVehicleVisitingPointsImages()
      return
    }

    if (
      !newVisit.vehicleVisitingPoints.skipVideo &&
      newVisit.vehicleVisitingPoints.videoStatus != 1
    ) {
      uploadVehicleVisitingPointsImages()
      return
    }

    if (newVisit.notHealthyAutoParts.data.some(x => x.status != 1)) {
      uploadNotHealthyAutoPartsImages()
      return
    }

    if (newVisit.vehicleAccessories.data.some(x => x.status != 1)) {
      uploadVehicleAccessoriesImages()
      return
    }

    saveVisit()
  }

  const uploadCustomerDeliberatelyImages = () => {
    if (newVisit.storeFileType == 'POD_SPACE') {
      dispatch(
        getUploadLink({
          data: { sizeInKB: uploadLinkSize, visitId: 0, type: 1 },
          handleNext: uploadVehicleVisitingPointsImages,
        }),
      )
    } else {
      dispatch(
        uploadDeliberateliesFiles({
          handleNext: uploadVehicleVisitingPointsImages,
        }),
      )
    }
  }

  const uploadVehicleVisitingPointsImages = () => {
    if (newVisit.storeFileType == 'POD_SPACE')
      // if (newVisit.uploadLink.link) {
      //     dispatch(uploadVehicleVisitingPointFilesPodSpace({ handleNext: uploadNotHealthyAutoPartsImages, videoFormat, uploadLink: newVisit.uploadLink.link }))
      // } else {
      dispatch(
        getUploadLink({
          data: { sizeInKB: uploadLinkSize, visitId: 0, type: 2 },
          handleNext: uploadNotHealthyAutoPartsImages,
          videoFormat,
        }),
      )
    // }
    else {
      dispatch(
        uploadVehicleVisitingPointFiles({
          handleNext: uploadNotHealthyAutoPartsImages,
          videoFormat,
        }),
      )
    }
  }

  const uploadNotHealthyAutoPartsImages = () => {
    if (newVisit.storeFileType == 'POD_SPACE') {
      // if (newVisit.uploadLink.link) {
      //     dispatch(uploadNotHealthyAutoPartsFilesPodSpace({ handleNext: uploadVehicleAccessoriesImages, uploadLink: newVisit.uploadLink.link }))
      // } else {
      dispatch(
        getUploadLink({
          data: { sizeInKB: uploadLinkSize, visitId: 0, type: 3 },
          handleNext: uploadVehicleAccessoriesImages,
        }),
      )
      // }
    } else {
      dispatch(uploadNotHealthyAutoPartsFiles(uploadVehicleAccessoriesImages))
    }
  }

  const uploadVehicleAccessoriesImages = () => {
    if (newVisit.storeFileType == 'POD_SPACE') {
      // if (newVisit.uploadLink.link) {
      //     dispatch(uploadVehicleAccessoriesFilesPodSpace({ handleNext: null, uploadLink: newVisit.uploadLink.link }))
      // } else {
      dispatch(
        getUploadLink({
          data: { sizeInKB: uploadLinkSize, visitId: 0, type: 4 },
          handleNext: null,
        }),
      )
      // }
    } else {
      dispatch(uploadVehicleAccessoriesFiles(null))
    }
  }

  const saveVisit = () => {
    dispatch(
      createVisit({
        data: {
          visitDate: gregorianDate(newVisit.createTime),
          cityId:
            newVisit.customerInfo?.visitLocationType == 1 ? newVisit.customerInfo.cityId : null,
          insuranceTypeId: 984,
          issuanceReasonVisitId: 43,
          personType: newVisit.customerInfo.personType,
          nationalityID: newVisit.customerInfo.nationalityID,
          firstName: newVisit.customerInfo.firstName,
          lastName: newVisit.customerInfo.lastName,
          identityCode: newVisit.customerInfo.identityCode,
          birthDate: newVisit.customerInfo.birthDate,
          gender: newVisit.customerInfo.gender,
          mobilePhoneNumber: newVisit.customerInfo.mobilePhoneNumber,
          plateType:
            newVisit.carInfo.plate?.type === 'UNDEFINED'
              ? 100
              : newVisit.carInfo.plate?.type === 'CAR'
                ? 1
                : newVisit.carInfo.plate?.type === 'MOTOR_CYCLE'
                  ? 2
                  : newVisit.carInfo.plate?.type === 'TEMPORARY'
                    ? 4
                    : newVisit.carInfo.plate?.type === 'FREEZONE'
                      ? 3
                      : null,
          plateCityCode:
            newVisit.carInfo.plate?.cityCode || newVisit.carInfo.plate?.serialPlate?.value,
          plateChar: newVisit.carInfo.plate?.char,
          plateCarSerial: newVisit.carInfo.plate?.carSerial,
          plateCarOtherNumber: newVisit.carInfo.plate?.carOtherNumber,
          PlateSerialId: newVisit.carInfo.plate?.serialPlate?.id,
          plateMotorCycleSerial: newVisit.carInfo.plate?.motorCycleSerial,
          plateAdditionalNumber:
            newVisit.carInfo.plate?.englishNumber || newVisit.carInfo.plate?.motorCycleOtherNumber,
          cargoCompartmentId: newVisit.carInfo.cargoCompartmentId,
          vehicleTypeId: newVisit.carInfo.vehicleTypeId,
          vehicleBrandId: newVisit.carInfo.vehicleBrandId,
          vehicleTipId: newVisit.carInfo.vehicleTipId,
          vehicleColorId: newVisit.carInfo.vehicleColorId,
          vehicleUsageId: newVisit.carInfo.vehicleUsageId,
          vehicleStatus: Number(newVisit.carInfo.vehicleStatus) - 1,
          numberOfCylinders: newVisit.carInfo.numberOfCylinders,
          yearOfConstruction: newVisit.carInfo.yearOfConstruction,
          vehicleMileage: Number(String(newVisit.carInfo.vehicleMileage).replace(/,/g, '')),
          chassisNumber: newVisit.carInfo.chassisNumber,
          engineNumber: newVisit.carInfo.engineNumber,
          VIN: newVisit.carInfo.VIN,
          price: newVisit.prices.price,
          totalValue: newVisit.prices.totalValue,
          towingValue: newVisit.prices.towingValue,
          description: newVisit.description,

          videoId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.vehicleVisitingPoints.videoFileId,
          videoHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.vehicleVisitingPoints.videoHashFile
              : null,
          videoHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.vehicleVisitingPoints.videoHashFileType
              : null,
          videoHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.vehicleVisitingPoints.videoHashFileExtension
              : null,
          videoHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.vehicleVisitingPoints.videoHashFileSize
              : null,
          nationalCardId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.nationalCard?.fileId,
          nationalCardHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCard?.hashFile
              : null,
          nationalCardHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCard?.hashFileType
              : null,
          nationalCardHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCard?.hashFileExtension
              : null,
          nationalCardHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCard?.hashFileSize
              : null,
          nationalCardBackId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.nationalCardBack?.fileId,
          nationalCardBackHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCardBack?.hashFile
              : null,
          nationalCardBackHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCardBack?.hashFileType
              : null,
          nationalCardBackHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCardBack?.hashFileExtension
              : null,
          nationalCardBackHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.nationalCardBack?.hashFileSize
              : null,
          vehicleDeliberatelyType:
            newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
              ? 1
              : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? 2
                : 3,
          vehicleCardId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCard?.fileId
                : null,
          vehicleCardHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCard?.hashFile
                : null
              : null,
          vehicleCardHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCard?.hashFileType
                : null
              : null,
          vehicleCardHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCard?.hashFileExtension
                : null
              : null,
          vehicleCardHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCard?.hashFileSize
                : null
              : null,
          vehicleCardBackId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCardBack?.fileId
                : null,
          vehicleCardBackHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCardBack?.hashFile
                : null
              : null,
          vehicleCardBackHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCardBack?.hashFileType
                : null
              : null,
          vehicleCardBackHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCardBack?.hashFileExtension
                : null
              : null,
          vehicleCardBackHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? newVisit.customerDeliberately.vehicleCardBack?.hashFileSize
                : null
              : null,
          vehicleDocId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? newVisit.customerDeliberately.vehicleDoc?.fileId
                : null,
          vehicleDocHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? newVisit.customerDeliberately.vehicleDoc?.hashFile
                : null
              : null,
          vehicleDocHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? newVisit.customerDeliberately.vehicleDoc?.hashFileType
                : null
              : null,
          vehicleDocHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? newVisit.customerDeliberately.vehicleDoc?.hashFileExtension
                : null
              : null,
          vehicleDocHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                ? newVisit.customerDeliberately.vehicleDoc?.hashFileSize
                : null
              : null,
          vehicleCompanyDocId:
            newVisit.storeFileType == 'POD_SPACE'
              ? null
              : newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                ? newVisit.customerDeliberately.vehicleCompanyDoc?.fileId
                : null,
          vehicleCompanyDocHashFile:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile
                : null
              : null,
          vehicleCompanyDocHashFileType:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileType
                : null
              : null,
          vehicleCompanyDocHashFileExtension:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileExtension
                : null
              : null,
          vehicleCompanyDocHashFileSize:
            newVisit.storeFileType == 'POD_SPACE'
              ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileSize
                : null
              : null,
          visitLocationType: newVisit.customerInfo?.visitLocationType,
          latitude:
            newVisit.customerInfo?.visitLocationType == 1
              ? newVisit.customerInfo.location?.latitude
              : null,
          longitude:
            newVisit.customerInfo?.visitLocationType == 1
              ? newVisit.customerInfo.location?.longitude
              : null,
          address:
            newVisit.customerInfo?.visitLocationType == 1
              ? newVisit.customerInfo.location?.address
              : 'در محل واحد صدور',

          dispatchLocation:
            newVisit.customerInfo?.visitLocationType == 1
              ? newVisit.customerInfo.location?.address
              : 'در محل واحد صدور',
          maritalStatus: 1,
          birthPlace: 'AAAAAA',
          placeOfIssue: 'AAAAAA',
          fatherName: 'AAAAA',
          checkCivilRegistry: false,
          isPodSpaceEnable: newVisit.storeFileType == 'POD_SPACE',

          visitVehicleOptionDetailIds: newVisit.vehicleOptions.map(x => {
            return x.vehicleOptionDetailId
          }),
          visitVehicleVisitingPoints: newVisit.vehicleVisitingPoints.data.map(x => {
            return {
              vehicleVisitingPointId: x.id,
              visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
              visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
              visitHashFileExtension:
                newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
              visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
              visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
              description: '',
            }
          }),
          visitAutoParts: newVisit.notHealthyAutoParts.data.map(x => {
            return {
              autoPartId: x.id,
              visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
              visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
              visitHashFileExtension:
                newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
              visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
              visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
              isHealthy: false,
              description: x.description,
              damagePercent: 0,
              amountOfDamages: 0,
            }
          }),
          visitVehicleAccessories: newVisit.vehicleAccessories.data.map(x => {
            return {
              vehicleAccessoryId: x.id,
              visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
              visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
              visitHashFileExtension:
                newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
              visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
              visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
              accessoryValue: x.price,
              description: x.description,
            }
          }),
        },
        navigate,
      }),
    )
  }

  return (
    <React.Fragment>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-center gap-2">
          <div className="text-lg font-bold pl-2 relative">
            {t('SEND_TO_SERVER')}
            <span
              className={`w-[10px] h-[10px] rounded-full absolute left-0 top-0 ${newVisit.storeFileType == 'POD_SPACE' ? 'bg-success' : 'bg-error'}`}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col grow overflow-auto">
        {!customerDeliberately() &&
        !newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) &&
        !(newVisit.vehicleVisitingPoints.videoStatus != 1) &&
        !newVisit.notHealthyAutoParts.data.some(x => x.status != 1) &&
        !newVisit.vehicleAccessories.data.some(x => x.status != 1) ? (
          t('SEND_VISIT_TO_SERVER_MESSAEG')
        ) : (
          <React.Fragment>
            {customerDeliberately() && (
              <div className="px-6 pb-6">
                {t('DELIBERATELY')}
                <div className="grid grid-cols-2 gap-4" style={{ marginBottom: '20px' }}>
                  {newVisit.customerDeliberately.nationalCard != undefined && (
                    <div
                      style={{ position: 'relative' }}
                      className={
                        newVisit.customerDeliberately.loading &&
                        Number(newVisit.customerDeliberately.nationalCard?.status) != 1
                          ? 'loading'
                          : ''
                      }
                    >
                      <PodSpaceImage
                        isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                        className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                        hashFile={newVisit.customerDeliberately.nationalCard?.hashFile}
                        fileId={newVisit.customerDeliberately.nationalCard?.fileId}
                        fileContent={newVisit.customerDeliberately.nationalCard?.image}
                        onLoad={(image: string) =>
                          dispatch(
                            setVehicleVisitingPointFileContent({
                              id: newVisit.customerDeliberately.nationalCard?.id,
                              image,
                            }),
                          )
                        }
                      >
                        <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                          {t('NATIONAL_CARD_FRONT')}
                        </div>
                      </PodSpaceImage>
                      {Number(newVisit.customerDeliberately.nationalCard?.status) == 1 ? (
                        <span
                          style={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            fontSize: 10,
                          }}
                        >
                          {t('UPLOADED')}
                        </span>
                      ) : (
                        ''
                      )}

                      {newVisit.customerDeliberately.loading &&
                        Number(newVisit.customerDeliberately.nationalCard?.status) != 1 &&
                        Number(newVisit.customerDeliberately.nationalCard?.uploadProgress) > 0 &&
                        Number(newVisit.customerDeliberately.nationalCard?.uploadProgress) <
                          100 && (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >{`%${Math.round(Number(newVisit.customerDeliberately.nationalCard?.uploadProgress))}`}</span>
                        )}
                    </div>
                  )}

                  {newVisit.customerDeliberately.nationalCardBack != undefined && (
                    <div
                      style={{ position: 'relative' }}
                      className={
                        newVisit.customerDeliberately.loading &&
                        Number(newVisit.customerDeliberately.nationalCardBack?.status) != 1
                          ? 'loading'
                          : ''
                      }
                    >
                      <PodSpaceImage
                        isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                        className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                        hashFile={newVisit.customerDeliberately.nationalCardBack?.hashFile}
                        fileId={newVisit.customerDeliberately.nationalCardBack?.fileId}
                        fileContent={newVisit.customerDeliberately.nationalCardBack?.image}
                        onLoad={(image: string) =>
                          dispatch(
                            setVehicleVisitingPointFileContent({
                              id: newVisit.customerDeliberately.nationalCardBack?.id,
                              image,
                            }),
                          )
                        }
                      >
                        <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                          {t('NATIONAL_CARD_BACK')}
                        </div>
                      </PodSpaceImage>
                      {Number(newVisit.customerDeliberately.nationalCardBack?.status) == 1 ? (
                        <span
                          style={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            fontSize: 10,
                          }}
                        >
                          {t('UPLOADED')}
                        </span>
                      ) : (
                        ''
                      )}

                      {newVisit.customerDeliberately.loading &&
                        Number(newVisit.customerDeliberately.nationalCardBack?.status) != 1 &&
                        Number(newVisit.customerDeliberately.nationalCardBack?.uploadProgress) >
                          0 &&
                        Number(newVisit.customerDeliberately.nationalCardBack?.uploadProgress) <
                          100 && (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >{`%${Math.round(Number(newVisit.customerDeliberately.nationalCardBack?.uploadProgress))}`}</span>
                        )}
                    </div>
                  )}

                  {newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
                    newVisit.customerDeliberately.vehicleCard != undefined && (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCard?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={newVisit.customerDeliberately.vehicleCard?.hashFile}
                          fileId={newVisit.customerDeliberately.vehicleCard?.fileId}
                          fileContent={newVisit.customerDeliberately.vehicleCard?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: newVisit.customerDeliberately.vehicleCard?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {t('VEHICLE_CARD_FRONT')}
                          </div>
                        </PodSpaceImage>
                        {Number(newVisit.customerDeliberately.vehicleCard?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCard?.status) != 1 &&
                          Number(newVisit.customerDeliberately.vehicleCard?.uploadProgress) > 0 &&
                          Number(newVisit.customerDeliberately.vehicleCard?.uploadProgress) <
                            100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(newVisit.customerDeliberately.vehicleCard?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )}

                  {newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
                    newVisit.customerDeliberately.vehicleCardBack != undefined && (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCardBack?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={newVisit.customerDeliberately.vehicleCardBack?.hashFile}
                          fileId={newVisit.customerDeliberately.vehicleCardBack?.fileId}
                          fileContent={newVisit.customerDeliberately.vehicleCardBack?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: newVisit.customerDeliberately.vehicleCardBack?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {t('VEHICLE_CARD_BACK')}
                          </div>
                        </PodSpaceImage>
                        {Number(newVisit.customerDeliberately.vehicleCardBack?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCardBack?.status) != 1 &&
                          Number(newVisit.customerDeliberately.vehicleCardBack?.uploadProgress) >
                            0 &&
                          Number(newVisit.customerDeliberately.vehicleCardBack?.uploadProgress) <
                            100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(newVisit.customerDeliberately.vehicleCardBack?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )}

                  {newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
                    newVisit.customerDeliberately.vehicleDoc != undefined && (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleDoc?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={newVisit.customerDeliberately.vehicleDoc?.hashFile}
                          fileId={newVisit.customerDeliberately.vehicleDoc?.fileId}
                          fileContent={newVisit.customerDeliberately.vehicleDoc?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: newVisit.customerDeliberately.vehicleDoc?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {t('VEHICLE_DOC')}
                          </div>
                        </PodSpaceImage>
                        {Number(newVisit.customerDeliberately.vehicleDoc?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleDoc?.status) != 1 &&
                          Number(newVisit.customerDeliberately.vehicleDoc?.uploadProgress) > 0 &&
                          Number(newVisit.customerDeliberately.vehicleDoc?.uploadProgress) <
                            100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(newVisit.customerDeliberately.vehicleDoc?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )}

                  {newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
                    newVisit.customerDeliberately.vehicleCompanyDoc != undefined && (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCompanyDoc?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile}
                          fileId={newVisit.customerDeliberately.vehicleCompanyDoc?.fileId}
                          fileContent={newVisit.customerDeliberately.vehicleCompanyDoc?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: newVisit.customerDeliberately.vehicleCompanyDoc?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {t('VEHICLE_COMPANY_DOC')}
                          </div>
                        </PodSpaceImage>
                        {Number(newVisit.customerDeliberately.vehicleCompanyDoc?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.customerDeliberately.loading &&
                          Number(newVisit.customerDeliberately.vehicleCompanyDoc?.status) != 1 &&
                          Number(newVisit.customerDeliberately.vehicleCompanyDoc?.uploadProgress) >
                            0 &&
                          Number(newVisit.customerDeliberately.vehicleCompanyDoc?.uploadProgress) <
                            100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(newVisit.customerDeliberately.vehicleCompanyDoc?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )}
                </div>
              </div>
            )}

            {newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) && (
              <div className="px-6 pb-6">
                {t('VEHICLE_VISITING_POINTS')}
                <div className="grid grid-cols-2 gap-4" style={{ marginBottom: '20px' }}>
                  {newVisit.vehicleVisitingPoints.data.map((x, i) => {
                    return (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.vehicleVisitingPoints.loading && Number(x?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={x?.hashFile}
                          fileId={x?.fileId}
                          fileContent={x?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: x?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {x.name}
                          </div>
                        </PodSpaceImage>
                        {Number(x?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.vehicleVisitingPoints.loading &&
                          Number(x?.status) != 1 &&
                          Number(x?.uploadProgress) > 0 &&
                          Number(x?.uploadProgress) < 100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(x?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )
                  })}
                </div>
              </div>
            )}

            {!newVisit.vehicleVisitingPoints.skipVideo &&
              newVisit.vehicleVisitingPoints.videoStatus != 1 && (
                <div className="px-6 pb-6">
                  {t('VEHICLE_VISITING_POINT_VIDEO')}
                  {newVisit.vehicleVisitingPoints.videoLoading &&
                    newVisit.vehicleVisitingPoints.videoStatus != 1 &&
                    newVisit.vehicleVisitingPoints.videoUploadProgress > 0 &&
                    newVisit.vehicleVisitingPoints.videoUploadProgress < 100 && (
                      <span
                        style={{ fontSize: 10 }}
                      >{`${Math.round(newVisit.vehicleVisitingPoints.videoUploadProgress)}%`}</span>
                    )}

                  <div
                    className={
                      newVisit.vehicleVisitingPoints.videoLoading &&
                      newVisit.vehicleVisitingPoints.videoStatus != 1
                        ? 'loading'
                        : ''
                    }
                  >
                    <video
                      autoPlay={false}
                      ref={videoPlayerRef}
                      style={{ maxWidth: '100%', height: '250px' }}
                      controls
                    />
                  </div>
                </div>
              )}

            {newVisit.notHealthyAutoParts.data.some(x => x.status != 1) && (
              <div className="px-6 pb-6">
                {t('NOT_HEALTHY_AUTO_PARTS')}
                <div className="grid grid-cols-2 gap-4" style={{ marginBottom: '20px' }}>
                  {newVisit.notHealthyAutoParts.data.map((x, i) => {
                    return (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.notHealthyAutoParts.loading && Number(x?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={x?.hashFile}
                          fileId={x?.fileId}
                          fileContent={x?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: x?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {x.name}
                          </div>
                        </PodSpaceImage>
                        {Number(x?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.notHealthyAutoParts.loading &&
                          Number(x?.status) != 1 &&
                          Number(x?.uploadProgress) > 0 &&
                          Number(x?.uploadProgress) < 100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(x?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )
                  })}
                </div>
              </div>
            )}

            {newVisit.vehicleAccessories.data.some(x => x.status != 1) && (
              <div className="px-6 pb-6">
                {t('VEHICLE_ACCESSORIES')}
                <div className="grid grid-cols-2 gap-4" style={{ marginBottom: '20px' }}>
                  {newVisit.vehicleAccessories.data.map((x, i) => {
                    return (
                      <div
                        style={{ position: 'relative' }}
                        className={
                          newVisit.vehicleAccessories.loading && Number(x?.status) != 1
                            ? 'loading'
                            : ''
                        }
                      >
                        <PodSpaceImage
                          isPodSpace={newVisit.storeFileType == 'POD_SPACE'}
                          className="flex items-end w-40 h-36 rounded-lg border border-gray-600 bg-cover bg-no-repeat bg-center overflow-hidden"
                          hashFile={x?.hashFile}
                          fileId={x?.fileId}
                          fileContent={x?.image}
                          onLoad={(image: string) =>
                            dispatch(
                              setVehicleVisitingPointFileContent({
                                id: x?.id,
                                image,
                              }),
                            )
                          }
                        >
                          <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                            {x.name}
                          </div>
                        </PodSpaceImage>
                        {Number(x?.status) == 1 ? (
                          <span
                            style={{
                              position: 'absolute',
                              top: 5,
                              right: 5,
                              fontSize: 10,
                            }}
                          >
                            {t('UPLOADED')}
                          </span>
                        ) : (
                          ''
                        )}

                        {newVisit.vehicleAccessories.loading &&
                          Number(x?.status) != 1 &&
                          Number(x?.uploadProgress) > 0 &&
                          Number(x?.uploadProgress) < 100 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                fontSize: 10,
                              }}
                            >{`%${Math.round(Number(x?.uploadProgress))}`}</span>
                          )}
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>

      <div className="cta">
        {newVisit.uploadLink.loading ||
        newVisit.customerDeliberately.loading ||
        newVisit.vehicleVisitingPoints.loading ||
        newVisit.vehicleVisitingPoints.videoLoading ||
        newVisit.notHealthyAutoParts.loading ||
        newVisit.vehicleAccessories.loading ? (
          ''
        ) : (
          <React.Fragment>
            {(updateWithOutError || newVisit.hasError) && (
              <button
                className="btn btn-info btn-lg flex gap-2 items-center justify-center w-full"
                onClick={() => navigate(VisitsPaths.NewVisit)}
              >
                {t('UPDATE')}
              </button>
            )}
            {canSkipVideo &&
              !newVisit.vehicleVisitingPoints.skipVideo &&
              checkIsJustVideoFile() && (
                <button
                  className="btn btn-info btn-lg flex gap-2 items-center justify-center w-full"
                  onClick={() => dispatch(setSkipVideo(true))}
                >
                  {t('SKIP_VIDEO')}
                </button>
              )}
          </React.Fragment>
        )}
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            disabled={
              newVisit.uploadLink.loading ||
              newVisit.customerDeliberately.loading ||
              newVisit.vehicleVisitingPoints.loading ||
              newVisit.vehicleVisitingPoints.videoLoading ||
              newVisit.notHealthyAutoParts.loading ||
              newVisit.vehicleAccessories.loading
            }
            onClick={() => navigate(VisitsPaths.VisitsMain)}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            disabled={
              newVisit.uploadLink.loading ||
              newVisit.customerDeliberately.loading ||
              newVisit.vehicleVisitingPoints.loading ||
              newVisit.vehicleVisitingPoints.videoLoading ||
              newVisit.notHealthyAutoParts.loading ||
              newVisit.vehicleAccessories.loading
            }
            onClick={onSaveHandleClick}
          >
            {t('SAVE')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SendToServerPage
